import jsPDF from "jspdf";

export interface BackupCodesPDFOptions {
  codes: string[];
  subtitle?: string;
  filename?: string;
}

export const generateBackupCodesPDF = ({
  codes,
  subtitle = "Save these codes securely. Each code can be used once.",
  filename = "backup-codes.pdf",
}: BackupCodesPDFOptions): void => {
  // Create new PDF document
  const doc = new jsPDF();

  // Set font
  doc.setFont("helvetica");

  // Add title
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("Backup Codes", 20, 30);

  // Add subtitle
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text(subtitle, 20, 45);

  // Add generation date
  const currentDate = new Date().toLocaleDateString();
  doc.setFontSize(10);
  doc.text(`Generated on: ${currentDate}`, 20, 60);

  // Add separator line
  doc.setLineWidth(0.5);
  doc.line(20, 70, 190, 70);

  // Add codes
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");

  let yPosition = 90;
  const lineHeight = 8;
  const codesPerColumn = 10;
  const leftMargin = 20;
  const rightColumnStart = 110;

  codes.forEach((code, index) => {
    const column = Math.floor(index / codesPerColumn);
    const row = index % codesPerColumn;

    const x = column === 0 ? leftMargin : rightColumnStart;
    const y = yPosition + row * lineHeight;

    // Add code number
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`${index + 1}.`, x, y);

    // Add code
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(code, x + 15, y);
  });

  // Add warning at the bottom
  const warningY =
    yPosition + Math.min(codes.length, codesPerColumn) * lineHeight + 20;
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(255, 0, 0); // Red color for warning
  doc.text("IMPORTANT:", 20, warningY);
  doc.text("• Store these codes in a secure location", 20, warningY + 8);
  doc.text("• Each code can only be used once", 20, warningY + 16);
  doc.text("• Do not share these codes with anyone", 20, warningY + 24);

  // Reset text color
  doc.setTextColor(0, 0, 0);

  // Save the PDF
  doc.save(filename);
};
